package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.dto.roster.ShiftTimeDto
import com.evoapps.evoshift.data.mapper.ShiftMapper
import com.evoapps.evoshift.domain.model.ClockAudit
import com.evoapps.evoshift.domain.model.ClockSource
import com.evoapps.evoshift.domain.model.ClockStamp
import com.evoapps.evoshift.domain.model.TimeRange

/**
 * SH-107: the audit stamps of actual times written from the app. An end (start or end) that does
 * not change keeps its stamp (a clock-in on the tablet stays "via tablet" when the person clocks
 * out on the phone); a changed one is the assignee's own (APP: the clock button or their own
 * correction) or a manager's (MANAGER). KIOSK stamps come only from the kioskClock function.
 */
object ActualTimeStamps {
    fun after(assigneeId: String?, before: ShiftTimeDto, actual: TimeRange?, editorUserId: String): ClockAudit? {
        val previous = ShiftMapper.clockAuditOf(before)
        val source = if (editorUserId == assigneeId) ClockSource.APP else ClockSource.MANAGER
        fun stamp(old: String, new: String, kept: ClockStamp?): ClockStamp? = when {
            new.isEmpty() -> null
            new == old -> kept
            else -> ClockStamp(source)
        }
        val start = stamp(before.start, actual?.start.orEmpty(), previous?.start)
        val end = stamp(before.end, actual?.end.orEmpty(), previous?.end)
        return if (start == null && end == null) null else ClockAudit(start, end)
    }
}
